<template>
  <RouterLink to="/" class="app-logo">
    <component
      :is="currentLogo"
      v-if="currentLogo"
      :style="{ width }"
      class="app-logo__image"
      aria-label="Company Logo"
    />
  </RouterLink>
</template>

<script setup lang="ts">
import { RouterLink } from '~/infrastructure';
import { computed } from 'vue';
import { useGetLogoViewModel } from '~/domains/core';

export interface Props {
  width?: number;
  variant?: 'light' | 'dark';
}

const { width = 108, variant = 'dark' } = defineProps<Props>();

const { logo } = useGetLogoViewModel();
const currentLogo = computed(() =>
  variant === 'dark' ? logo.value?.dark : logo.value?.light,
);
</script>

<style lang="scss" scoped>
.app-logo {
  overflow: hidden;
  display: inline-block;
  width: 100%;

  &__image {
    display: block;
    height: auto;
  }
}
</style>
